module.exports = __webpack_public_path__ + "img/mencion_honor.f5e4ff64.jpg";